export default __webpack_public_path__ + "static/media/venus2.397fdee2.png";